import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import { AgColor } from '../Styles/AgColor';
import { CSSProperties, ReactNode } from 'react';
import { Box } from '@mui/material';

const AgIconButton = ({
  icon,
  onClick,
  type,
  size,
  disabled,
  mainColor,
  label,
  style,
  buttonStyle
}:{
  icon?: ReactNode;
  onClick?: Function,
  type?: 'primary' | 'secondary',
  size?: 'large' | 'small',
  disabled?: boolean,
  mainColor?: CSSProperties['color'],
  label?: string,
  style?: CSSProperties
  buttonStyle?: CSSProperties
}) => {
  return (
    <Box
      style={{ height: 'max-content', width: 'max-content', ...style }}>
      <Box
        onClick={() => !disabled && onClick?.()}
        sx={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          border: `1px solid ${mainColor ?? AgColor.grey4}`,
          color: disabled ? AgColor.grey5 : mainColor,
          width: 'max-content', 
          height: size === 'small' ? '24px' : '32px',
          display: 'flex',
          gap: '7px',
          padding: '0px 25px',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '4px',
          '.MuiSvgIcon-root':{
            width: '16px', 
            height: '16px',
            color: disabled ? AgColor.grey5 : mainColor ? mainColor : type === 'secondary' ? AgColor.primaryDark : AgColor.secondaryDark
          },
          ':hover': {
            outline: `1px solid ${disabled ? AgColor.grey3 : AgColor.secondaryDark}`,
          },
          ...buttonStyle
        }}
      >
        {icon || <FolderCopyOutlinedIcon />} {label}
      </Box>
    </Box>
  );
};

export default AgIconButton;